import React from 'react';
import SwipeableViews from 'react-swipeable-views';

import SliderDots from 'common.components/slider-dots/slider-dots';

import Slide from '../__slide/how-to-start-modal__slide';

interface State {
    currentSlide: number;
}

class HowToStartModalMobileView extends React.Component<any, State> {
    state = {
        currentSlide: 0,
    };

    switchingHandler = (value: number) => {
        const { currentSlide } = this.state;

        const newCurrentSlide = Math.round(value);

        if (currentSlide !== newCurrentSlide) {
            this.setState({ currentSlide: newCurrentSlide });
        }
    };

    render() {
        const { currentSlide } = this.state;

        return (
            <React.Fragment>
                <SliderDots activeIndex={currentSlide} numberDots={3} />
                <SwipeableViews
                    enableMouseEvents
                    onSwitching={this.switchingHandler}
                    slideStyle={{ justifyContent: 'center', display: 'flex' }}
                >
                    <Slide
                        imgKey="howToStartModal.firstColumn.image.src"
                        markdownId="howToStartModal.firstColumn.title"
                        textId="howToStartModal.firstColumn.text"
                    />
                    <Slide
                        imgKey="howToStartModal.secondColumn.image.src"
                        markdownId="howToStartModal.secondColumn.title"
                        textId="howToStartModal.secondColumn.text"
                    />
                    <Slide
                        imgKey="howToStartModal.thirdColumn.image.src"
                        markdownId="howToStartModal.thirdColumn.title"
                        textId="howToStartModal.thirdColumn.text"
                    />
                </SwipeableViews>
            </React.Fragment>
        );
    }
}

export default HowToStartModalMobileView;
